import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, NgZone, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
	selector: 'app-warning-message',
	templateUrl: './warning-message.component.html',
	styleUrls: ['./warning-message.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
  ]
})
export class WarningMessageComponent implements OnInit, OnDestroy {

	@ViewChild('mycontainer', { static: false, read: ElementRef }) input: ElementRef | any;

	height: number = 0
	observer!: ResizeObserver;
	enableCompact: boolean = false;

	@Input()
	hasClose: boolean = true

	@Input()
	contrast: boolean = false

	@Output()
	close: EventEmitter<boolean> = new EventEmitter()

	public hide: boolean = false

	constructor(private zone: NgZone) { }

	ngOnInit(): void {
		this.observer = new ResizeObserver(entries => {
			this.zone.run(() => {
				this.height = entries[0].contentRect.height;
				if (this.height > 64) {
					this.enableCompact = true
				} else {
					this.enableCompact = false
				}
			});
		});
	}

	doClose() {
		this.observer.unobserve(this.input.nativeElement)
		this.hide = true
		this.close.emit(true)
	}

	ngAfterViewInit() {
		this.observer.observe(this.input.nativeElement);
	}

	ngOnDestroy(): void {
		if (this.input != null) {
			this.observer.unobserve(this.input.nativeElement)
		}
	}

}
